import UserInvitation from './UserInvitation'

export default UserInvitation;